import moment from 'moment';
import URL_ROUTE from '../constants/index';
export const HOST = process.env.REACT_APP_HOST_API;
export const VERSION = 'api/v1/';

class Api {
    async validateForm(id) {
        const url = `${HOST}${VERSION}web/contrato/getContratoCompleto/${id}`;
        const query = await fetch(`${url}`, {
            method: "GET",
            headers: {
                'Content-Type': 'application/json'
            },
        });
        return query
    }

    async saveForm(idContrato, firma, foto, html_contrato, id_html_contrato) {
        let data = {
            contrato_id: idContrato, firma_usuario: firma, foto_firma_usuario: foto, html_contrato: html_contrato, id_html_contrato: id_html_contrato
        }
        const query = await fetch(`${URL_ROUTE.SAVEFORM}`, {
            method: "POST",
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(data)
        });
        return query
    }

    async exportarContrato(idContrato) {
        let data = { idContrato }
        const query = await fetch(`${URL_ROUTE.EXPORTARCONTRATO}`, {
            method: "POST",
            headers: {
                'Content-Type': 'application/json',
            },
            responseType: 'blob',
            body: JSON.stringify(data),
        });
        return query
    }

}

export default new Api();
